// src/redux/actions/resetActions.ts
import { createAction } from '@reduxjs/toolkit';

export const resetState = createAction('resetState');